import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { CAMPAIGN_VARIANT_TOP_SPACING } from '../campaignSpacing';
import { LocationFeaturesWidgetComponent } from './LocationFeaturesWidgetComponent';

export function LocationFeaturesWidgetComponentC(
  props: React.ComponentProps<typeof LocationFeaturesWidgetComponent>,
) {
  return (
    <LocationFeaturesWidgetComponent
      {...props}
      className={classNames(props.className, CAMPAIGN_VARIANT_TOP_SPACING)}
    />
  );
}
